<template>
  <div>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col cols="6" class="text-left">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
          </v-col>
        </v-row>
        <v-row>
          <v-col style="padding-top: 0">
            <v-tabs v-model="tab" align-with-title style="margin: 0px">
              <v-tabs-slider color="blue"></v-tabs-slider>

              <v-tab v-for="item in items" :key="item.name">
                {{ item.name }}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab" style="padding: 10px">
              <v-tab-item>
                <v-sheet style="height: 80vh" color="#fff" width="100%">
                  <!-- <v-container> -->
                    <h2>ตั้งค่าการแจ้งเตือน</h2>
                    <p>
                      เมื่อเปิดการแจ้งเตือน
                      ลูกค้าของร้านนั้นๆจะได้รับการแจ้งเตือนในผ่าน Application
                      LINE เมื่อมีการเพิ่มคะแนนให้กับลูกค้า
                      <span style="color: red"
                        >**<a
                          href="https://lineforbusiness.com/th/service/line-oa-features?utm_source=google&utm_medium=cpc&utm_campaign=oabroadcast&utm_content=sem&gad_source=1&gclid=CjwKCAiA29auBhBxEiwAnKcSqihRwN2v2j6gw3XnLmqP2RcVhRUZ_AYQ0GEU1G2eEyxi2MPGhX7AmhoCw-EQAvD_BwE#monthlyplan"
                          target="_blank"
                          >เงื่อนไขการใช้บริการแจ้งเตือนผ่าน LINE</a
                        >
                      </span>
                      หากไม่ต้องการใช้สามารถปิดการแจ้งเตือนได้
                    </p>
                    <div
                      style="
                        display: flex;
                        justify-content: center;
                        width: 100%;
                      "
                    >
                      <div v-if="statusnotifyAddcoin === true">
                        <v-btn
                          outlined
                          color="error"
                          @click="updateStatusnotifyAddcoin()"
                          >กดเพื่อปิดการใช้งาน</v-btn
                        >
                      </div>
                      <div v-if="statusnotifyAddcoin === false">
                        <v-btn
                          outlined
                          color="success"
                          @click="updateStatusnotifyAddcoin()"
                          >กดเพื่อเปิดการใช้งาน</v-btn
                        >
                      </div>
                    </div>
                  <!-- </v-container> -->
                </v-sheet>
              </v-tab-item>
              <v-tab-item>
                <v-sheet style="height: 100%; width: 100%" color="#fff">
                    <div>
                      <h2>BOT แจ้งเตือนผ่าน LINE</h2>
                    <p>
                      เมื่อเปิดการใช้งาน บอทจะแจ้งเตือนกิจกรรมต่างๆ ในกลุ่ม LINE
                      ที่กำหนด
                    </p>
                    </div>

                  <div
                    class="d-flex justify-content-center align-items-center"
                    style="height: 70vh"
                    v-if="dataLineNoti.length === 0"
                  >
                    <v-btn
                      color="#1B437C"
                      depressed
                      dark
                      @click="(dialogAddNotify = true), validate('ADD')"
                    >
                      <v-icon left>mdi-bell-ring</v-icon>
                      เปิดการใช้งาน Bot
                    </v-btn>
                  </div>

                  <v-row v-else>
                    <v-col
                      cols="12"
                    >
                      <v-sheet color=''>

                      <v-container>
                        <v-row>
                          <v-col><h2>Group</h2></v-col>
                          <v-col class="text-right">
                            <v-btn color='error' @click="deleteData(dataLineNoti)">ลบ</v-btn>
                          </v-col>
                        </v-row>

                        <h3>กลุ่ม {{ dataLineNoti. target}}</h3>
                      <p class="mb-0">ประเภท {{ dataLineNoti. targetType}}</p>
                      <p class="mb-0">วันที่สร้าง {{ thaiFormattedDate(dataLineNoti. CREATE_DATE)}}</p>
                      <p class="mb-0">วันที่แก้ไขล่าสุด {{ thaiFormattedDate(dataLineNoti. LAST_DATE)}}</p>
                        <v-divider></v-divider>
                        <v-col cols='3' class="p-0">
                          <v-checkbox v-model='checkboxPackage' label='ใช้งานแจ้งเตือนเกี่ยวกับแพ็กเกจ' hide-details></v-checkbox>
                        </v-col>
                        <v-col cols='3' class="p-0">
                          <v-checkbox v-model='checkboxBirthday' label='ใช้งานแจ้งเตือนเกี่ยวกับวันเกิด' hide-details></v-checkbox>
                        </v-col>
                        <v-divider></v-divider>
                        <v-row>
                          <v-col class="text-right">
                            <v-btn color='success' @click="submit(dataLineNoti.idGroup_LineNotify)">บันทึก</v-btn>
                          </v-col>
                        </v-row>

                      </v-container>

                    </v-sheet></v-col>
                  </v-row>
                </v-sheet>
              </v-tab-item>
              <v-tab-item>
                <v-sheet
                  style="height: 100%"
                  color="#fff"
                  height="100%"
                  width="100%"
                >
                  <div
                    style="
                      width: 100%;
                      height: 100vh;
                      display: flex;
                      flex-direction: column;
                      justify-content: center;
                      align-items: center;
                    "
                    v-if="notifyBirthDay.status === 0"
                  >
                    <p>
                      หากต้องการใช้งานการแจ้งเตือนวันเกิดล่วงหน้าให้เปิดใช้งานและตั้งค่าให้เรียบร้อย
                    </p>
                    <br />
                    <v-btn dark color="#1b437c" @click="updateStatus()"
                      >เปิดใช้งาน</v-btn
                    >
                  </div>
                  <div v-if="notifyBirthDay.status === 1">
                    <v-row
                      align="center"
                      justify="center"
                      style="padding-top: 30px"
                    >
                      <v-sheet height="100vh" width="100%">
                        <v-row>
                          <v-col
                            cols="12"
                            xs="12"
                            sm="12"
                            md="12"
                            lg="12"
                            class="text-right"
                          >
                            <v-btn color="error" @click="updateStatus()">
                              ปิดใช้งาน
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row justify="center">
                          <v-row>
                            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                              <v-form
                                ref="form"
                                v-model="valid"
                                lazy-validation
                              >
                                <div
                                  style="display: flex; justify-content: center"
                                >
                                  <v-card
                                    @click="chooseImage"
                                    class="image-input"
                                    :style="{
                                      'background-image': `url(${notifyBirthDay.pictureUrlPreview})`,
                                      'background-size': 'contain',
                                      'background-position': 'center center',
                                      'background-repeat': 'no-repeat',
                                    }"
                                  >
                                    <div
                                      style="
                                        position: absolute;
                                        top: -12px;
                                        right: -12px;
                                      "
                                      v-if="
                                        notifyBirthDay.pictureUrlPreview !==
                                          '' &&
                                        notifyBirthDay.pictureUrlPreview !==
                                          null
                                      "
                                    >
                                    </div>
                                    <span
                                      v-if="
                                        notifyBirthDay.pictureUrlPreview === ''
                                      "
                                      class="placeholder"
                                      style="
                                        justify-content: center;
                                        align-items: center;
                                        display: flex;
                                        height: 100%;
                                      "
                                      >Choose an Image</span
                                    >
                                    <input
                                      style="display: none"
                                      class="file-input"
                                      ref="fileInput"
                                      type="file"
                                      @input="onSelectFile"
                                      :rules="[rules.required]"
                                    />
                                  </v-card>
                                </div>

                                <div
                                  style="
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                  "
                                >
                                  <p style="color: rgb(125, 126, 128)">
                                    ขนาดรูปภาพที่แนะนำขนาด(กว้าง x ยาว) คือ 250
                                    x 250 Pixel
                                  </p>
                                </div>
                                <div
                                  style="display: flex; justify-content: center"
                                >
                                  <div style="min-width: 40%">
                                    <p>
                                      ข้อความที่ต้องการส่งให้แจ้งเตือนล่วงหน้า
                                    </p>
                                    <v-textarea
                                      v-model="notifyBirthDay.detail"
                                      placeholder="ข้อความที่ต้องการส่ง"
                                      outlined
                                      dense
                                      :rules="[rules.required]"
                                    ></v-textarea>
                                    <p>จำนวนวันที่จะให้แจ้งเตือนล่วงหน้า</p>
                                    <v-text-field
                                      v-model="notifyBirthDay.count_day"
                                      placeholder=""
                                      outlined
                                      dense
                                      min="1"
                                      type="number"
                                      :rules="[rules.required]"
                                    ></v-text-field>
                                    <div class="row">
                                      <div class="col text-right">
                                        <v-btn
                                          color="success"
                                          @click="
                                            validate(), updateNotiBirthDay()
                                          "
                                          >บันทึก
                                        </v-btn>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </v-form>
                            </v-col>
                          </v-row>
                        </v-row>
                      </v-sheet>
                    </v-row>
                  </div>
                </v-sheet>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>

        <v-row>
          <v-dialog v-model="dialogAddNotify" persistent width="45%">
            <v-card class="pa-3" min-height="200" style="overflow-x: hidden">
              <v-row>
                <v-col cols="10" class="text-left pt-10">
                  <h3 class="ml-7">
                    <strong>เลือกสาขารับการแจ้งเตือน</strong>
                  </h3>
                  <h3 class="ml-7">
                    <p>(สำหรับการแจ้งเตือนซื้อแพ็กเกจ)</p>
                  </h3>
                </v-col>
                <v-col cols="2" class="pt-10">
                  <div style="text-align: end; color: red">
                    <v-btn
                      class="mx-2"
                      fab
                      small
                      color="white"
                      @click="dialogAddNotify = false"
                    >
                      X
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
              <v-row class="pa-6 pt-2">
                <v-col class="pa-0" cols="12">
                  <v-select
                    v-model="itemBranch"
                    :items="Branch"
                    label="เลือกสาขาที่ต้องการรับการแจ้งเตือน"
                    dense
                    outlined
                    multiple
                    item-value="masBranchID"
                    item-text="masBranchName"
                    persistent-hint
                    attach
                    :menu-props="{ bottom: true, offsetY: true }"
                    class="ma-3"
                  ></v-select>
                </v-col>
              </v-row>
              <div class="mr-4">
                <v-btn
                  block
                  class="ma-2"
                  color="#14AE5C"
                  dark
                  large
                  @click="AddDataNotify()"
                >
                  บันทึก
                </v-btn>
              </div>
            </v-card>
          </v-dialog>
          <!-- end add -->

          <!-- delete -->
          <v-dialog v-model="dialogDelete" persistent max-width="40%">
            <v-card>
              <v-card-title>
                <span class="headline pa-3">ลบข้อมูลนี้</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="6">
                      <v-text-field
                        label="ไอดีกลุ่มไลน์"
                        outlined
                        dense
                        v-model="formUpdate.notifyId"
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="formUpdate.target"
                        label="ชื่อกลุ่มไลน์"
                        dense
                        outlined
                        readonly
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  dark
                  x-large
                  class="btn-color"
                  @click="dialogDelete = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  dark
                  x-large
                  color="red darken-1"
                  @click="deleteData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  ลบ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end delete -->

          <v-dialog v-model="dialogSelectBranch" max-width="600px" persistent>
            <v-card class="py-4">
              <v-card-text>
                <v-container class="pa-5">
                  <v-row>
                    <v-col cols="12" style="padding-bottom: 0">
                      <v-select
                        v-model="selectBranch"
                        :items="Branch"
                        item-value="masBranchID"
                        item-text="masBranchName"
                        label="กรุณเลือกสาขา"
                        required
                        outlined
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions style="justify-content: center; padding-top: 0">
                <v-row>
                  <v-col cols="12" class="pb-0">
                    <v-btn
                      color="green"
                      style="color: white"
                      block
                      @click="createPackageAndAddbranch()"
                      :disabled="selectBranch === null"
                    >
                      สร้าง Qrcode แพ็กเกจ
                    </v-btn>
                  </v-col>
                  <v-col cols="12">
                    <v-btn
                      color="red"
                      style="color: white"
                      block
                      @click="
                        (selectBranch = null), (dialogSelectBranch = false)
                      "
                    >
                      ปิด
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import moment from 'moment-timezone'

export default {
  components: {},
  data () {
    return {
      checkboxPackage: '',
      checkboxBirthday: '',
      path: '/lineNotify/', // Path Model
      returnLink: '/Master/Package',
      Branch: null,
      selectBranch: null,
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'ตั้งค่าแจ้งเตือน',
          disabled: false,
          href: '/Master/Package'
        }
      ],
      items: [
        { name: 'แจ้งเตือนผ่านลูกค้าเมื่อมีการแจกคะแนน' },
        { name: 'Bot แจ้งเตือนผ่าน LINE' },
        { name: 'แจ้งเตือนล่วงหน้าวันเกิด' }
      ],
      tab: null,
      dataReady: true,
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      dialogAdd: false,
      dialogDelete: false,
      session: this.$session.getAll(),
      dialogSelectBranch: false,
      dialogAddNotify: false,
      filesAdd: null,
      filesUpdate: null,
      nowDate: new Date().toISOString().slice(0, 10),
      dataItem: [],
      loadingAdd: false,
      itemBranch: null,
      notifyId: '',
      dataLineNoti: [],
      formUpdate: {
        packageId: '',
        packageImg: '',
        packageName: '',
        packageCount: '',
        packagePrice: '',
        packagePoint: '',
        packageExpri: '',
        packageDetail: '',
        flowId: '',
        CREATE_USER: '',
        LAST_USER: '',
        pictureUrlPreview: '',
        shopId: ''
      },
      notifyBirthDay: {
        pictureUrlPreview: '',
        pictureUrl: '',
        detail: '',
        status: 0,
        count_day: '',
        LAST_USER: '',
        shopId: ''
      },
      Id: '',
      absolute: true,
      overlay: false,
      rules: {
        required: (value) => !!value || 'กรุณากรอก.'
      },
      valid: true,
      statusnotifyAddcoin: null
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    try {
      console.log(this.DNS_IP + '/lineNotify/get?shopId=' + this.session.data.shopId)
      this.dataReady = false
      this.getDataLineNotify()
      await this.checkNotifyStatusAddcoin()
      await this.getBranch()
      this.getData_Noti_birthday()
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    validate () {
      this.$refs.form.validate()
      console.log(this.$refs.form.validate())
    },
    getDataLineNotify () {
      this.dataLineNoti = []
      this.dataReady = true
      axios
        .get(this.DNS_IP + '/lineNotify/get?shopId=' + this.session.data.shopId)
        .then((res) => {
          if (res.data.status === false) {
            this.dataLineNoti = []
          } else {
            this.dataLineNoti = res.data[0]
            console.log('dddd', this.dataLineNoti)
            if (res.data[0].package === 'false' || res.data[0].package === 'False') {
              this.checkboxPackage = false
            } else {
              this.checkboxPackage = true
            }
            if (res.data[0].birthday === 'false' || res.data[0].birthday === 'False') {
              this.checkboxBirthday = false
            } else {
              this.checkboxBirthday = true
            }
          }
        })
    },
    selectImgUpdate () {
      if (this.filesUpdate) {
        this.formUpdate.pictureUrlPreview = URL.createObjectURL(
          this.filesUpdate
        )
      } else {
        this.formUpdate.pictureUrlPreview = ''
      }
    },
    selectImg () {
      if (this.filesAdd) {
        this.formAdd.pictureUrlPreview = URL.createObjectURL(this.filesAdd)
      } else {
        this.formAdd.pictureUrlPreview = ''
      }
    },
    async getBranch () {
      await axios
        .get(
          this.DNS_IP +
            '/master_branch/get?shopId=' +
            this.$session.getAll().data.shopId
        )
        .then(async (response) => {
          this.Branch = response.data
        })
        .catch((error) => {
          console.log('error function getBranchBelink : ', error)
        })
    },
    AddDataNotify () {
      this.notifyId = moment().valueOf()
      this.$swal({
        title: 'ต้องการบันทึกข้อมูลใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      }).then(async (result) => {
        let dataAdd = {
          notifyId: this.notifyId.toString(),
          masBranchID: JSON.stringify(this.itemBranch),
          shopId: this.$session.getAll().data.shopId,
          CREATE_USER: this.$session.getAll().data.userName,
          LAST_USER: this.$session.getAll().data.userName
        }
        await axios
          .post(this.DNS_IP + '/lineNotify/add', dataAdd)
          .then(async (response) => {
            this.$swal('บันทึกข้อมูลเรียบร้อย', ' ', 'success')
            this.dialog = false
            window.location.href =
              'https://notify-bot.line.me/oauth/authorize?response_type=code&client_id=jNXllez6GPLFH7T9Iz37zN' +
              '&scope=notify&state=HHNpz31GikuOlYnujmDvHZXcK4e2REjuiXmOwwn3Nwu' +
              '&redirect_uri=https://betask-loyalty-app.web.app/UpdateNotify?shopId=' +
              this.$session.getAll().data.shopId +
              'notifyId' +
              this.notifyId
          })
          // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            console.log('error function addData : ', error)
          })
        console.log('dataAdd', dataAdd)
      })
    },
    async deleteData (item) {
      console.log(item)
      this.formUpdate.LAST_USER = this.session.data.userName
      console.log('DELETE PK : ', item.notifyId)
      axios
        .post(
          this.DNS_IP + '/lineNotify/delete/' + item.notifyId,
          this.formUpdate
        )
        .then((res) => {
          this.dataReady = false
          this.$swal('เรียบร้อย', 'ลบข้อมูลเรียบร้อย', 'success')
          this.getDataLineNotify()
        })
    },
    chooseImage () {
      this.$refs.fileInput.click()
    },
    onSelectFile () {
      this.input = this.$refs.fileInput
      console.log(this.input.value)
      this.filesAdd = this.input.files
      if (this.filesAdd && this.filesAdd.length > 0) {
        this.notifyBirthDay.pictureUrlPreview = URL.createObjectURL(
          this.filesAdd[0]
        )
        this.notifyBirthDay.pictureUrl = URL.createObjectURL(this.filesAdd[0])
      } else {
        this.notifyBirthDay.pictureUrlPreview = ''
      }

      this.$forceUpdate()
    },
    deleteImg () {
      console.log(this.filesAdd)
      this.filesAdd = null
      this.notifyBirthDay.pictureUrlPreview = ''
      this.notifyBirthDay.pictureUrl = ''
      this.input.value = ''
    },
    getData_Noti_birthday () {
      console.log(
        this.DNS_IP + '/Notify_Birthday/get?shopId=' + this.session.data.shopId
      )
      axios
        .get(
          this.DNS_IP +
            '/Notify_Birthday/get?shopId=' +
            this.session.data.shopId
        )
        .then((res) => {
          console.log('res_getData_Noti_birthday', res.data)
          if (res.data.status !== false) {
            this.notifyBirthDay.pictureUrl = res.data[0].pictureUrl
            this.notifyBirthDay.pictureUrlPreview = res.data[0].pictureUrl
            this.notifyBirthDay.detail = res.data[0].detail
            this.notifyBirthDay.count_day = res.data[0].count_day
            this.notifyBirthDay.status = res.data[0].status
            this.Id = res.data[0].id
            if (this.notifyBirthDay.status === 1) {
              this.overlay = false
            } else if (this.notifyBirthDay.status === 0) {
              this.overlay = true
            }
            // console.log(this.notifyBirthDay)
          }
        })
    },
    async updateNotiBirthDay () {
      if (this.$refs.form.validate() === true) {
        await axios
          .get(
            this.DNS_IP +
              '/Notify_Birthday/get?shopId=' +
              this.session.data.shopId
          )
          .then(async (res) => {
            if (res.data.status === false) {
              console.log('res.data', res.data)

              // insert
              console.log(this.notifyBirthDay)
              delete this.notifyBirthDay['pictureUrlPreview']
              this.notifyBirthDay.shopId = this.session.data.shopId
              if (this.filesAdd) {
                const _this = this
                let params = new FormData()
                params.append('file', this.filesAdd[0])

                await axios
                  .post(this.DNS_IP + `/file/upload/reward`, params)
                  .then(async function (response) {
                    _this.notifyBirthDay.pictureUrl = response.data
                  })
              }
              await axios
                .post(this.DNS_IP + '/Notify_Birthday/add', this.notifyBirthDay)
                .then(async (res) => {
                  this.getData_Noti_birthday()
                  console.log(res)
                  this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
                })
              console.log('res.data', res.data)
            } else {
              // update
              var Id = res.data[0].id
              this.notifyBirthDay.LAST_USER = this.session.data.userName
              this.notifyBirthDay.shopId = this.session.data.shopId
              delete this.notifyBirthDay['pictureUrlPreview']
              if (this.filesAdd) {
                const _this = this
                let params = new FormData()
                params.append('file', this.filesAdd[0])

                await axios
                  .post(this.DNS_IP + `/file/upload/reward`, params)
                  .then(async function (response) {
                    _this.notifyBirthDay.pictureUrl = response.data
                  })
              }
              await axios
                .post(
                  this.DNS_IP + '/Notify_Birthday/edit/' + Id,
                  this.notifyBirthDay
                )
                .then(async (res) => {
                  this.getData_Noti_birthday()
                  console.log(res)
                  this.$swal('สำเร็จ', 'บันทึกข้อมูลสำเร็จ', 'success')
                })
              console.log('res.data', res.data)
            }
          })
      } else {
        this.$swal('ไม่สำเร็จ', 'กรุณากรอกข้อมูลให้ครบถ้วน', 'info')
      }
    },
    async updateStatus () {
      console.log(this.notifyBirthDay.status)
      var data = {}
      var detail = ''
      axios
        .get(
          this.DNS_IP +
            '/Notify_Birthday/get?shopId=' +
            this.session.data.shopId
        )
        .then((res) => {
          if (res.data.status === false) {
            this.notifyBirthDay.CREATE_USER = this.session.data.userName
            this.notifyBirthDay.LAST_USER = this.session.data.userName
            this.notifyBirthDay.shopId = this.session.data.shopId
            this.notifyBirthDay.status = 1
            this.notifyBirthDay.pictureUrl =
              'https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/BD2.png?alt=media&token=77b64ad4-db5a-45eb-9e80-60885526140a'
            this.notifyBirthDay.detail =
              'สุขสันต์วันเกิดล่วงหน้าให้กับคุณ ขอให้เป็นช่วงเวลาที่ดี'
            this.notifyBirthDay.count_day = 1
            delete this.notifyBirthDay['pictureUrlPreview']

            axios
              .post(this.DNS_IP + '/Notify_Birthday/add', this.notifyBirthDay)
              .then(async (res) => {
                this.getData_Noti_birthday()
              })
          } else {
            if (this.notifyBirthDay.status === 1) {
              // update 0
              data = {
                status: 0
              }
              detail = 'ปิดใช้งาน'
            } else {
              // update 1
              data = {
                status: 1
              }
              detail = 'เปิดใช้งาน'
            }
            axios
              .post(this.DNS_IP + '/Notify_Birthday/edit/' + this.Id, data)
              .then(async (res) => {
                this.getData_Noti_birthday()
                this.$swal('เรียบร้อย', detail, 'success')
              })
          }
        })
    },
    async updateStatusnotifyAddcoin () {
      console.log('updateStatusnotifyAddcoin', this.statusnotifyAddcoin)
      if (this.statusnotifyAddcoin === true) {
        this.dataNew = this.$session.getAll().data
        this.dataNew.notify_status_addcoin = 'False'
      } else {
        this.dataNew = this.$session.getAll().data
        this.dataNew.notify_status_addcoin = 'True'
      }
      localStorage.setItem('data', JSON.stringify(this.dataNew))
      this.$session.set('data', this.dataNew)
      this.checkNotifyStatusAddcoin()
      const DT = {
        notify_status_addcoin: this.statusnotifyAddcoin
      }
      console.log('aaa', DT)
      await axios
        .post(
          this.DNS_IP +
            '/system_shop/edit/' +
            this.$session.getAll().data.shopId,
          DT
        )
        .then((res) => {
          console.log('this.them', res)
        })
    },
    checkNotifyStatusAddcoin () {
      try {
        console.log('feojfpejfpef', this.$session.getAll().data)
        if (
          this.$session.getAll().data.notify_status_addcoin.toLowerCase() ===
          'true'
        ) {
          this.statusnotifyAddcoin = true
        } else {
          this.statusnotifyAddcoin = false
        }
      } catch (error) {
        console.log('error', error)
      }
    },
    submit (id) {
      let data = {
        package: this.checkboxPackage,
        birthday: this.checkboxBirthday
      }
      axios.post(this.DNS_IP + '/lineNotify/edit/' + id, data).then(res => {
        console.log(res.data)
        this.$swal('สำเร็จ', 'บันทึกข้อมูลสำเร็จ', 'success')
        this.getDataLineNotify()
      })
    }
  }
}
</script>
<style scoped>
h3 {
  font-size: 18.72px !important;
}

.image-input {
  display: block;
  width: 300px;
  height: 300px;
  /* min-width: 300px;
  min-height: 300px; */
  cursor: pointer;
  background-size: cover;
  background-position: center center;
}
.v-application--is-ltr .v-tabs--align-with-title>.v-tabs-bar:not(.v-tabs-bar--show-arrows):not(.v-slide-group--is-overflowing)>.v-slide-group__wrapper>.v-tabs-bar__content>.v-tabs-slider-wrapper+.v-tab {
    margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/System/NotifySetting.vue